export class StringUtils {
    public static titleCase(str: string) {
        return str.trim().split(/\s+/).map((s) => s[0].toUpperCase() + s.slice(1).toLowerCase()).join(" ");
    }

    public static quote(s: any): string {
        return "'" + s + "'";
    }

    public static isNumber(s: any): boolean {
        return /^\d+$/.test(s);
    }

    public static toScale(n: number, scale: number): string {
        return n == undefined ? undefined : n.toFixed(scale).replace(/([0-9]+(\.[0-9]+[1-9])?)(\.?0+$)/,"$1");
    }
}



// WEBPACK FOOTER //
// ./src/app/string-utils/string-utils.ts